import { Stack, StackProps } from '@mui/material';

const CenterBox = (props: StackProps) => (
  <Stack height="100%" justifyContent="center" alignItems="center" width="100%" {...props} />
);

export default CenterBox;
